import { cn } from '@/lib/utils';

interface HorizontalProgressBarProps {
    value: number;
    className?: string;
}

export function HorizontalProgressBar({
    value,
    className,
}: HorizontalProgressBarProps) {
    const clamped = Math.min(100, Math.max(0, value));

    return (
        <div
            className={cn(
                'h-0.5 w-full overflow-hidden rounded-full bg-grey-600',
                className,
            )}
        >
            <div
                className="h-full rounded-full bg-white-100 shadow-[0_0_8px_rgba(255,255,255,0.35)] transition-[width] duration-300 ease-out"
                style={{ width: `${clamped}%` }}
            />
        </div>
    );
}
